import React, { useState, useEffect, Fragment, useRef } from "react";
import "./_home.scss";
import whiteLogo from "../../Assets/Images/Zencelogo.svg";
import access360 from "../../Assets/Images/access360.png";
import OmnichannelCustomerSupport from "../../Assets/Images/OmnichannelCustomerSupport.png";
import serviceEfficiency from "../../Assets/Images/serviceEfficiency.png";
import MultiAppsIntegration from "../../Assets/Images/MultiAppsIntegration.png";
import DeliverCustomerDelight from "../../Assets/Images/DeliverCustomerDelight.png";
import RealTimeReporting from "../../Assets/Images/RealTimeReporting.png";
import AgentEfficiency from "../../Assets/Images/AgentEfficiency.png";
import clientLogo from "../../Assets/Images/clientLogo.png";
import starRating from "../../Assets/Images/starRating.png";
import BookDemo from "../Login/BookDemo";
import LoginForm from "../Login/LoginForm";

export default function Home() {
  const [activeTab, setActiveTab] = useState(0);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleTabActive = (tabNo) => {
    setActiveTab(tabNo);
  };
  return (
    <Fragment>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="hero-heading roboto-bold">#RightToExclusiveOffer</h1>
              <h2 className="hero-sub-heading roboto-regular">Boost CSAT & Craft Seamless Experiences with</h2>
              <h2 className="hero-main-heading roboto-regular"><img src={whiteLogo}  alt="Zence Logo" /> Ticket Management</h2>
              <h3 className="hero-free-trial-para roboto-bold">
                <span>
                Start 1 Month Free Trial
                </span>
                </h3>
             
                <div className="mt-5 text-center visible-xs">
            <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Start Your Free Trial
                </button>
            </div>
            </div>
            <div className="col-lg-4 px-0 hidden-xs">
              <div className="login-container">
                <div className="input-form">
                  <h4 className="login-form-heading text-center roboto-bold">
                  INTERESTED? <br />
                    TALK TO AN EXPERT
                  </h4>
                  <LoginForm />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
        <div className="d-flex justify-content-end">
            <p className="t-and-c-text roboto-regular">*T&C Apply </p>
            </div>
        </div>
      </section>

      <section className="page-content stats-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 m-auto">
              <div className="stats-container">
                <div className="stats-card col">
                  <h4 className="roboto-bold">
                    <span className="white-dot"></span>99%
                  </h4>
                  <p className="roboto-regular">First Call Response</p>
                </div>
                <div className="stats-card col">
                  <h4 className="roboto-bold">
                    <span className="white-dot"></span>75%
                  </h4>
                  <p className="roboto-regular">
                    Reduction in Ticket Resolution Time
                  </p>
                </div>

                <div className="stats-card col">
                  <h4 className="roboto-bold">
                    <span className="white-dot"></span>2.5 Lacs
                  </h4>
                  <p className="roboto-regular">Ticket Resolved across channels in 9 months</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row mb-5">
            <div className="col-lg-11 m-auto">
                 <h4 className="page-heading roboto-bold text-center">Are you ensuring that your customers get the right support at the right time?</h4>
                 <p className="page-content-para roboto-regular text-center">Be on the top of your customer conversations & always deliver exceptional experiences with <b>Zence Ticket Desk solution</b></p>
            </div>

          </div>
          <div className="row align-items-center gap-3 column-reverse">
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img src={access360} className="main-image" alt="" />
               
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              
              <h4 className="text-heading roboto-bold mb-3">
              Access 360° Customer View 
              </h4>
              <p className="text-para roboto-regular">
              Know your customers and their past interactions with your brand before you start a conversation. View their information and preferences to offer tailor-made solutions 
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3">
            
            <div className="col-lg-5 col-md-6 m-auto">
              
              <h4 className="text-heading roboto-bold mb-3">
                Omnichannel Customer Support
              </h4>
              <p className="text-para roboto-regular">
              Be on top of the conversations coming in via multiple channels like email, phone, and social media from a single platform 
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img src={OmnichannelCustomerSupport} className="main-image" alt="" />
               
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>


      <section className="page-content">
        <div className="container-fluid">
         
          <div className="row align-items-center gap-3 column-reverse">
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img src={serviceEfficiency} className="main-image" alt="" />
               
              </div>
              <div className="mt-4 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              
              <h4 className="text-heading roboto-bold mb-3">
              Leverage AI to enhance customer service efficiency
              </h4>
              <ul className="section-ul">
                    <li>Ticket tagging with sentiment and emotion analysis</li>
                    <li>Mark high-priority tickets to ensure timely resolution</li>
                    <li>Detect intent and send first response automatically </li>
                    <li>Auto-detect sentiment and categorize tickets for proper handling </li>
                    <li>Auto-close tickets if no customer response to follow-ups </li>
                    <li>Automatically route sensitive and premium tickets to top agents </li>
                 </ul>
                 <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3">
            
            <div className="col-lg-5 m-auto">
              
              <h4 className="text-heading roboto-bold mb-3">
              Multi apps Integration to extend your helpdesk capabilities
              </h4>
              <p className="text-para roboto-regular">
               Maximize your desk efficiency by seamlessly integrating with a suite of essential apps, including an Order Management System, Payment Provider, WhatsApp / Service Bot  
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img src={MultiAppsIntegration} className="main-image" alt="" />
               
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>



      <section className="page-content claim-free-trial-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-9 m-auto">
              <p className="text-para roboto-regular">
              Is your current Ticketing tool not driving enough results?<br/> <b>Try Zence Ticket Management </b>
              </p>
            </div>
            <div className="col-lg-3">
            <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Start Your Free Trial
                </button>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
         
          <div className="row align-items-center gap-3 column-reverse">
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img src={DeliverCustomerDelight} className="main-image" alt="" />
               
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              
              <h4 className="text-heading roboto-bold mb-3">
              Deliver Customer Delight on Social Media
              </h4>
              <p className="text-para roboto-regular">Integrate social media platforms with Zence Ticket Management to provide swift resolutions</p>
               <ul className="section-ul">
                    <li>Translate comments to tickets</li>
                    <li>Ability to view & revert to comments and tag users </li>
                    <li>Detailed view of post content and interaction </li>
                    <li>Intent analysis </li>
                 </ul>
                 <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row align-items-center gap-3">
            
            <div className="col-lg-5  m-auto">
              
              <h4 className="text-heading roboto-bold mb-3">
              Intuitive and Real-time Reporting
              </h4>
              <p className="text-para roboto-regular">
              Track the progress of your tickets and their resolution time with an intuitive dashboard. This empowers you to proactively address customer concerns and ensure a consistently positive experience  
              </p>
              <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img src={RealTimeReporting} className="main-image" alt="" />
               
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
         
          <div className="row align-items-center gap-3 column-reverse">
            <div className="col-lg-6 p-0">
              <div className="page-image-container">
                <img src={AgentEfficiency} className="main-image" alt="" />
               
              </div>
              <div className="mt-2 mb-3 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              
              <h4 className="text-heading roboto-bold mb-3">
              Maximize Agent Efficiency
              </h4>
              
              <p className="text-para roboto-regular">Empower your agents with streamlined workflows and the right tools and knowledge to resolve issues faster </p>
               <ul className="section-ul">
                    <li>Send a feedback rating form to customers automatically upon ticket closure</li>
                    <li>Capture customer ratings for tickets </li>
                    <li>Compute daily and monthly CSAT ratings for agents based on customer ticket feedback </li>
                    <li>Offer leaders a dashboard to easily identify top and bottom-performing agents</li>
                    <li>Enhance ticket reports with detailed CSAT information </li>
                 </ul>
                 <div className="mt-3 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className="page-content industries-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 m-auto">
              <h4 className="text-heading roboto-bold mb-5 mt-0 text-center">Here’s what our Clients have to say </h4>
             
             <div className="client-review">
               <p className="star-container">
                 <span> <img src={clientLogo}  alt="" /></span>
                 <span><img src={starRating}  alt="" /></span>
               </p>
               <p className="text-para roboto-regular">
              “Amazing ticketing tool! It has completely transformed the way we handle customer complaints and support requests. Efficient, user-friendly, and a real game-changer for our business.” 
              </p>
              <p className="text-para roboto-regular">
              <b>- Shriniwas Kandlapalli</b>
              <br/>
              The Belgian Waffle Co.
              </p>
             </div>
              
            </div>
          </div>
        </div>
      </section>
      <section className="page-content claim-free-trial-section my-0">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-9 m-auto">
              <p className="text-para roboto-regular">
              Tired of Ticket Overload?<br/>
              Manage tickets effortlessly with <b>Zence AI-powered Ticket Management Solution</b>
              </p>
            </div>
            <div className="col-lg-3">
            <button
                  className="btn btn-schedule-demo roboto-medium"
                  onClick={() => handleShow()}>
                  Claim Your Free Trial
                </button>
            </div>
          </div>
        </div>
      </section>
      <section className="page-content industries-section mt-0 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 m-auto">
              <h4 className="text-normal-heading roboto-bold mb-3 mt-0">Terms and Conditions </h4>
              <ul className="section-ul ps-3">
                <li>Final subscription charges depend on applicable offer basis product suite and duration</li>
                <li>Zence reserves the right to withdraw the offer anytime </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <BookDemo showModal={show} handleCloseModal={handleClose} />
    </Fragment>
  );
}
